<template>
  <div class="domestic-sidebar-sp">
    <!-- コントローラ -->
    <div class="domestic-sidebar-sp__wrap --controller">
      <!-- 宿泊地 -->
      <div class="domestic-sidebar-sp__wrap">
        <p class="domestic-sidebar-sp__heading">宿泊地</p>
        <!-- TODO: 複数選択可能になったらisMultipleSelectをtrueに -->
        <ModalPrefectures
          modalType="area"
          labelText="宿泊地"
          placeHoldText="都道府県・市区町村を選択"
          :isError="errorMessage !== ''"
          :isLabelDisplay="false"
          :isFixedWidth="true"
          :isMultipleSelect="true"
          @inputed="setDestination"
        />
      </div>
      
      <!-- キーワード検索 -->
      <div class="domestic-sidebar-sp__wrap">
        <p class="domestic-sidebar-sp__heading">キーワード</p>
        <SearchKeyword
          :value="params.keyword"
          placeholder="施設名など"
          :isError="errorMessage !== ''"
          :useSearchButton="false"
          @inputed="setKeyword"
        />
      </div>

      <!-- 期間・宿泊日数 と 部屋数 -->
      <div class="domestic-sidebar-sp__row">
        <!-- 期間・宿泊日数 -->
        <div class="domestic-sidebar-sp__row-item --period">
          <p class="domestic-sidebar-sp__heading">期間</p>
          <SelectStayPeriod @inputed="setPeriod" />
        </div>

        <!-- 部屋数 -->
        <div class="domestic-sidebar-sp__row-item --rooms">
          <p class="domestic-sidebar-sp__heading">部屋数</p>
          <AppSelectNumber
            :numbers="10"
            :value="params.roomCnt"
            label="部屋"
            class="domestic-sidebar-sp__rooms"
            @inputed="setRooms"
          />
        </div>
      </div>

      <!-- 1部屋のご利用人数 -->
      <div class="domestic-sidebar-sp__wrap">
        <p class="domestic-sidebar-sp__heading">1部屋のご利用人数</p>
        <SelectNumPeople
          :adultHeadCnt="params.adultHeadCnt"
          :exUpperGradesHeadCnt="params.exUpperGradesHeadCnt"
          :exLowerGradesHeadCnt="params.exLowerGradesHeadCnt"
          :youjiAHeadCnt="params.youjiAHeadCnt"
          :youjiBHeadCnt="params.youjiBHeadCnt"
          :youjiCHeadCnt="params.youjiCHeadCnt"
          :youjiDHeadCnt="params.youjiDHeadCnt"
          @inputed="setNumPeople"
        />
      </div>

      <!-- 1人あたりの料金（1泊） -->
      <div class="domestic-sidebar-sp__wrap">
        <p class="domestic-sidebar-sp__heading">予算（総額）</p>
        <SelectPriceRange
          :feeLower="params.feeLower"
          :feeUpper="params.feeUpper"
          @inputed="setPrice"
        />
      </div>

      <!-- エラーメッセージ（SP） -->
      <div
        v-if="errorMessage"
        class="domestic-sidebar-sp__error-message"
      >
        <ErrorMessageForIncorrectInput
          :errorMessage="errorMessage"
          deviceType="sp"
        />
      </div>

      <!-- この条件で絞り込むボタン -->
      <div class="domestic-sidebar-sp__wrap">
        <AppButton
          label="この条件で絞り込む"
          theme="black"
          :height="40"
          :maxWidth="640"
          @clicked="clicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import specialConditionsList from '../specialConditionsList.json'
import SearchKeyword from '../SearchKeyword/'
import SelectStayPeriod from'../SelectStayPeriod/'
import SelectNumPeople from'../SelectNumPeople/'
import SelectPriceRange from '../SelectPriceRange/'
import ModalPrefectures from '../ModalPrefectures'
import ErrorMessageForIncorrectInput from '../ErrorMessageForIncorrectInput/'
import AppButton from '@/components/elements/AppButton/'
import AppSelectNumber from '@/components/elements/AppSelectNumber/'

export default {
  components: {
    SearchKeyword,
    SelectStayPeriod,
    SelectNumPeople,
    SelectPriceRange,
    ModalPrefectures,
    ErrorMessageForIncorrectInput,
    AppButton,
    AppSelectNumber,
  },
  props: {
    errorMessage: {
      type: String,
      required: false,
      default: ''
    }, // エラーメッセージ
  },
  data() {
    return {
      dest: [],
      facility: [],               // 施設タイプ（データ加工用）
      roomType: [],               // 部屋タイプ（データ加工用）
      mealCondition: [],          // 食事条件（データ加工用）
      roomCondition: [],          // 部屋のこだわり（データ加工用）
      serviceEquip: [],           // 設備・サービス（データ加工用）
      usageMethod: [],            // 利用方法（データ加工用）
      planByCompany: [],          // 提供会社（データ加工用）

      params: {                   // BFFリクエスト用パラメータ
        numPeople: 1,             // 合計人数
        adultHeadCnt: 1,          // 大人の人数
        feeLower: '0',            // 下限金額
        feeUpper: '0',            // 上限金額
        facility: '',             // 施設タイプ
        roomType: '',             // 部屋タイプ
        mealCondition: '',        // 食事条件
        roomCondition: '',        // 部屋のこだわり
        serviceEquip: '',         // 設備・サービス
        usageMethod: '',          // 利用方法
        planByCompany: '',        // 提供会社
        checkInDate: '',          // 宿泊開始日
        areaLrgClassCd: '',       // 地方
        areaMidClassCd: '',       // 都道府県
        areaSmlClassCd: '',       // 市区町村
        areaDtlClassCd: '',       // エリア
        keyword: '',              // 検索キーワード
        stayNights: 1,            // 宿泊日数
        orderBy: 'PROPOSE',       // ソート条件（「おすすめ順」がデフォルト）
        category: 'stay',         // 国内宿泊施設（stay）
        exUpperGradesHeadCnt: 0,  // 高学年
        exLowerGradesHeadCnt: 0,  // 低学年
        youjiAHeadCnt: 0,         // 食事・布団付き
        youjiBHeadCnt: 0,         // 食事のみ
        youjiCHeadCnt: 0,         // 布団のみ
        youjiDHeadCnt: 0,         // 食事・布団不要
        roomCnt: 1,               // 部屋数
      },
      isModalVisible: false       // こだわり条件モーダルの表示状態
    }
  },
  created() {
    this.initStateFromQuery()
  },
  methods: {
    /**
     * 「この条件で絞り込む」ボタンが押下されたら
     */
    clicked() {
      this.initSpecialConditions()
      this.setOrderBy()
      this.$emit('inputed', this.params,this.dest)
    },
    /**
     * 初期値をクエリパラメータから取得し、反映
     */
    initStateFromQuery() {
      const query = this.$route.query
      const keys = Object.keys(this.params)

      keys.forEach(key => {
        this.params[key] = query?.[key] || this.params[key]
      })
    },
    /**
     * こだわり条件の初期化（チェック状態のプロパティを追加）
     */
    initSpecialConditions() {
      const query = this.$route.query
      specialConditionsList.forEach(item => {
        if (query[item.id] !== undefined) {
          const currentCheckedItems = query[item.id]
          this.params[item.id] = currentCheckedItems
        } else {
          this.params[item.id] = ''
        }
      })
    },
    /**
     * 並び替えを設定
     * 並び替えだけ独立した検索条件なので
     * emit時にqueryから都度取得する
     */
    setOrderBy() {
      const query = this.$route.query
      this.params.orderBy = query?.orderBy
    },
    /**
     * keywordを設定
     */
    setKeyword(value) {
      this.params.keyword = value
    },
    /**
     * SelectDestinationからemitされたobjectから値を設定
     */
    setDestination(obj) {
      this.dest = obj;
      this.params.areaLrgClassCd = obj.region_id
      this.params.areaMidClassCd = obj.large_id
      this.params.areaSmlClassCd = obj.medium_id
      this.params.areaDtlClassCd = obj.small_id
    },
    /**
     * SelectStayPeriodからemitされたobjectから値を設定
     */
    setPeriod(obj) {
      this.params.checkInDate = obj.checkInDate
      this.params.stayNights = obj.stayNights
    },
    /**
     * AppSelectNumberからemitされたroomCntを設定
     */
    setRooms(value) {
      this.params.roomCnt = Number(value) || 0
      // roomsはroomCntと同じらしい
      this.params.rooms = Number(value) || 0
    },
    /**
     * 
     * @param {*} obj 
     */
    setNumPeople(obj) {
      this.params.adultHeadCnt = obj.adultHeadCnt
      this.params.exLowerGradesHeadCnt = obj.exLowerGradesHeadCnt
      this.params.exUpperGradesHeadCnt = obj.exUpperGradesHeadCnt
      this.params.youjiAHeadCnt = obj.youjiAHeadCnt
      this.params.youjiBHeadCnt = obj.youjiBHeadCnt
      this.params.youjiCHeadCnt = obj.youjiCHeadCnt
      this.params.youjiDHeadCnt = obj.youjiDHeadCnt

      // 食事のみ、食事・布団不要は人数に含まない
      this.params.numPeople =
        Number(obj.adultHeadCnt) +
        Number(obj.exLowerGradesHeadCnt) +
        Number(obj.exUpperGradesHeadCnt) +
        Number(obj.youjiAHeadCnt) +
        Number(obj.youjiCHeadCnt)
    },
    setPrice(obj) {
      this.params.feeLower = obj.feeLower
      this.params.feeUpper = obj.feeUpper
    },
    /**
     * SelectSpecialConditionsからemitされたこだわり条件を設定
     */
    setSpecialConditions(newList, type) {
      this[type] = newList

      // checkedの真偽値だけを抽出し、paramsへ「hoge,fuga...」の形式で代入
      const checkedItems = newList
        .filter(d => d.checked)
        .map(d => d.id).join()
      this.params[type] = checkedItems
    },
    /**
     * ModalSpecialConditionsで設定された値を設定
     */
    setSpecialConditionsFromModal(obj) {
      // keyのみの配列作成
      const types = specialConditionsList.map(d => d.id)

      types.forEach(type => {
        // this.facility, this.roomType等に、modalが返したcheckedを更新したリストを代入
        this[type] = obj[type]

        // checkedの真偽値だけを抽出し、paramsへ「hoge,fuga...」の形式で代入
        const checkedItems = obj[type]
          .filter(d => d.checked)
          .map(d => d.id).join()
        this.params[type] = checkedItems
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.domestic-sidebar-sp {
  &__wrap {
    padding: 0 1rem 1rem;

    &.--controller {
      // border: 2px solid $cool-gray-4;
      // border-radius: .5rem;
      padding: 1rem 0 0;
    }
  }

  &__row {
    align-items: center;
    column-gap: .5rem;
    display: flex;
    padding: 0 1rem 1rem;
  }

  &__row-item {
    &.--period {
      width: calc(100% - 5rem);
    }

    &.--rooms {
      width: 4.5rem;
    }
  }

  &__title {
    color: $black;
    font-weight: bold;
    line-height: 1.5;

    &.--top {
      border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0;
      font-size: 1.25rem;
      margin-bottom: 1.5rem;
    }

    &.--special {
      background-color: $cool-gray-5;
      font-size: .875rem;
      margin-bottom: 1rem;
      padding: .5rem 1rem;
    }
  }

  &__error-message {
    margin-bottom: .5rem;
    padding: 0 1rem;
  }

  &__heading {
    font-size: .875rem;
    font-weight: bold;
    margin-bottom: .25rem;

    &.--special {
      margin-bottom: 1rem;
    }
  }

  &__block {
    &.--destination {
      align-items: center;
      align-content: stretch;
      display: flex;
      font-size: .75rem;
      line-height: 1.25;
      padding: .5rem 0;

      &::before {
        content: '設定中:';
        display: block;
        flex-shrink: 0;
        margin-right: .5rem;
      }
    }
  }

  &__rooms {
    border: 1px solid $cool-gray-3;
    border-radius: .25rem;
    height: 2.5rem;
    width: 100%;
  }

  &__select-special-conditions {
    &.--room-type {
      border-bottom: 1px solid $cool-gray-4;
      padding-bottom: 1rem;
    }
  }
}
</style>